/*
 * discount-input.js — Rabattcode-Eingabe auf der Produktseite (Block blocks/discount-input.liquid).
 * 27.09.2026: aus dem Inline-Skript des Blocks ausgelagert (gecacht, defer). Logik unveraendert; statt eines
 * Blocks per Liquid-ID werden alle [data-discount-input-component] initialisiert, die es noch nicht sind.
 * Spricht window.DiscountPreviewEngine (assets/discount-engine.js) an und hoert auf discount-preview:restored.
 */
(function () {
  function init(root) {
    if (!root || root.dataset.discountInputInitialized) return;
    root.dataset.discountInputInitialized = 'true';

    var input = root.querySelector('[data-discount-input]');
    var checkBtn = root.querySelector('[data-discount-check]');
    var checkText = root.querySelector('[data-discount-check-text]');
    var message = root.querySelector('[data-discount-message]');

    function setMessage(text, state) {
      message.textContent = text;
      message.hidden = !text;
      if (state) {
        message.setAttribute('data-state', state);
      } else {
        message.removeAttribute('data-state');
      }
    }

    function setChecking(isChecking) {
      checkBtn.disabled = isChecking;
      checkText.textContent = isChecking ? 'Prüfe…' : (checkText.dataset.original || checkText.textContent);
      if (!isChecking) return;
      checkText.dataset.original = checkText.dataset.original || checkText.textContent;
    }

    function runCheck(code) {
      if (!window.DiscountPreviewEngine) {
        setMessage('Rabattprüfung ist momentan nicht verfügbar. Bitte Seite neu laden.', 'error');
        return;
      }
      setChecking(true);
      setMessage('', null);
      window.DiscountPreviewEngine.checkCode(code)
        .then(function (result) {
          setMessage(result.message, result.ok ? 'success' : 'error');
        })
        .finally(function () {
          setChecking(false);
        });
    }

    checkBtn.addEventListener('click', function () {
      runCheck(input.value);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        runCheck(input.value);
      }
    });

    // Reagiert, wenn die Engine (blocks/discount-engine.liquid)
    // automatisch einen Code übernommen hat (GET-Parameter oder bereits
    // aktiver Warenkorb-Rabatt) - Feld und Meldung entsprechend füllen.
    document.addEventListener('discount-preview:restored', function (event) {
      var detail = event.detail || {};
      if (detail.code) {
        input.value = detail.code;
      }
      if (detail.message) {
        setMessage(detail.message, 'success');
      }
      openSurroundingAccordion();
    });

    // Liegt der Block in einem Akkordeon (details/accordion-custom), soll das
    // bei automatisch übernommenem Code geöffnet sein. Die open-by-default-
    // Attribute sind nötig, weil accordion-custom den Open-Zustand beim
    // Upgrade und bei jedem Breakpoint-Wechsel daraus neu ableitet.
    function openSurroundingAccordion() {
      var details = root.closest('details');
      if (!details) return;
      var accordion = details.closest('accordion-custom');
      if (accordion) {
        accordion.setAttribute('open-by-default-on-desktop', '');
        accordion.setAttribute('open-by-default-on-mobile', '');
      }
      details.open = true;
    }

    if (!window.DiscountPreviewEngine) {
      console.warn(
        'Rabattcode-Eingabe: Keine Engine-Komponente auf dieser Seite gefunden. ' +
          'Bitte den Block "Rabattcode-Engine (global)" auf dieser Produktseite hinzufügen.'
      );
    }
  }
  var bloecke = document.querySelectorAll('[data-discount-input-component]');
  for (var i = 0; i < bloecke.length; i++) init(bloecke[i]);
})();
